import React, { Component } from 'react';
import { string, object, bool, oneOfType, arrayOf, func } from 'prop-types';
import isEqual from 'lodash/isEqual';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { isAgentLogged } from 'yoda-core-components/lib/helpers/Utils/Utils';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import YodaProductCartridge from '../YodaProductCartridge/YodaProductCartridge';
import BrandRecZone from '../BrandRecZone/BrandRecZone';
import {
    getProductListForCartridgeSlot,
    removeProductCartridgeSlot,
    addProductCartridgeSlot,
} from '../../actions/ProductCartridgeAction';
import withReducerSaga from '../../hoc/ReducerRegistry/withReducerSaga';
import ProductCartridgeReducer from '../../reducers/ProductCartridgeReducer';
import watchProductListRequest, { watchResetProductList } from '../../sagas/ProductCartridgeSaga';
import User from '../../helpers/User/User';

/* istanbul ignore next */
export class CertonaZone extends Component {
    static defaultProps = {
        page: '',
        pricingConfig: null,
        actions: {},
        productCartridgeSlots: {},
        slotDetails: {},
        schemasToRender: [],
        isTitle: true,
        isPLAEnabled: false,
        showLoader: false,
        showPaneLoader: true,
        showImageLoader: true,
        disableLazyLoad: false,
        emptyProductsReceived: null,
        forceRefresh: false,
        onProductClick: null,
        onCartridgeLoad: null,
        enableMiniPDP: false,
        disablePricingCall: false,
        productItemClass: '',
        enableGridViewInCertona: false,
        enableUrgencyMessagingOnATC: false,
        refreshCertona: null,
        isCouponRecommendationsModal: false,
        fromMiniPDP: false,
        fromCart: false,
        wrapperClass: '',
        abodeMap: {},
        adobeScheme: [],
        bottomPadding: '',
    };

    static propTypes = {
        /**
         * page id
         */
        page: string.isRequired,
        actions: object.isRequired,

        /**
         * Product slots list
         */
        productCartridgeSlots: object,

        /**
         * Details related to the page
         * eg: {
         *      pageType: '<PAGE>',
         *       attributes: {
         *           recommendations: true,
         *           categoryid: getCategoryNID(), - only for category page
         *       },
         *       loader: 'certona',
         *       slotId: '<slot_id>',
         *  }
         */
        slotDetails: object.isRequired,

        /**
         * RegionPricing enabled or not
         */
        pricingConfig: object,
        schemasToRender: oneOfType([string, arrayOf(string)]),
        isTitle: bool,
        isPLAEnabled: bool,
        disableLazyLoad: bool,
        showLoader: bool,
        showPaneLoader: bool,
        showImageLoader: bool,
        emptyProductsReceived: func,
        forceRefresh: bool,
        onProductClick: func,
        onCartridgeLoad: func,
        enableMiniPDP: bool,
        disablePricingCall: bool,
        productItemClass: string,
        enableGridViewInCertona: bool,
        enableUrgencyMessagingOnATC: bool,
        refreshCertona: func,
        isCouponRecommendationsModal: bool,
        fromMiniPDP: bool,
        fromCart: bool,
        wrapperClass: string,
        abodeMap: object.isRequired,
        adobeScheme: object,
    };

    constructor() {
        super();
        this.state = {
            productCartridgeSlots: {},
            removeLoader: false,
            isLoaded: false,
            isPriceLoaded: false,
        };
    }

    componentDidMount() {
        this.loadProductListForCartridgeSlot();
    }

    componentWillReceiveProps(nextProps) {
        const { productCartridgeSlots, schemasToRender, refreshCertona } = nextProps;
        const { productCartridgeSlots: prevCartridgeSlots } = this.props;
        if (refreshCertona) {
            this.refreshProductListForCartridgeSlot(nextProps);
        }

        if (
            !prevCartridgeSlots?.[schemasToRender] &&
            productCartridgeSlots?.[schemasToRender] &&
            !this.state.isLoaded
        ) {
            this.setState({
                productCartridgeSlots,
                removeLoader: true,
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        // If pricing call completed, then we need to repaint the cartridge
        const { productCartridgeSlots = {} } = nextProps;
        // isLoaded will be true when component initial load completed
        // for non-IE, if it is partially load, then isPriceLoaded will be true
        // after isLoaded set to true
        const { isLoaded, isPriceLoaded } = this.state;
        const { slotDetails } = this.props;
        const slot = slotDetails && slotDetails.slotId;
        // To Handle if certona loaded and pricing load asyns
        if (
            isLoaded &&
            !isPriceLoaded &&
            productCartridgeSlots[slot] &&
            productCartridgeSlots[slot].isPriceLoaded
        ) {
            return true;
        }

        // stopping rerendering of cateridges
        if (isLoaded) {
            return false;
        }

        if (
            !isEqual(
                JSON.stringify(slotDetails.attributes),
                JSON.stringify(nextProps.slotDetails.attributes)
            )
        ) {
            return true;
        }

        if (
            !nextState.removeLoader &&
            isEqual(this.props.productCartridgeSlots, nextProps.productCartridgeSlots)
        ) {
            return false;
        }
        return true;
    }

    componentWillUnmount() {
        const { schemasToRender, actions } = this.props;
        actions?.removeProductCartridgeSlot(schemasToRender);
    }

    getProductCartridges = () => {
        const { productCartridgeSlots } = this.state;
        const {
            isTitle,
            isPLAEnabled,
            slotDetails: { slotId, pageType },
            showPaneLoader,
            showImageLoader,
            disableLazyLoad,
            onProductClick,
            pricingConfig,
            enableMiniPDP,
            productItemClass,
            enableGridViewInCertona,
            enableUrgencyMessagingOnATC,
            isCouponRecommendationsModal,
            fromMiniPDP,
            fromCart,
        } = this.props;
        const cartrides = [];
        const slotInfo = productCartridgeSlots?.[slotId];
        if (slotInfo?.display === 'yes') {
            const catridgeProps = {
                productCartridgeList: slotInfo?.items || [],
                slotId,
                cartridgeHeader: slotInfo?.header || '',
                hasTitle: isTitle,
                isPLAEnabled,
                showPaneLoader,
                showImageLoader,
                disableLazyLoad,
                productCatridgeTheme: dt(['mt-0']),
                prodCatridgeWrapper: dt(['p-0']),
                onPaneClick: onProductClick,
                pricingConfig,
                pageType,
                panelType: 'CERTONA',
                enableMiniPDP,
                showPricing: slotInfo?.isPriceLoaded || false,
                priceDetails: slotInfo?.priceDetails || {},
                productItemClass,
                enableGridViewInCertona,
                enableUrgencyMessagingOnATC,
                isCouponRecommendationsModal,
                fromMiniPDP,
                fromCart,
                criteriaName: slotInfo?.criteriaName || '',
            };
            cartrides.push(<YodaProductCartridge key={slotId} {...catridgeProps} />);
        }
        return cartrides;
    };

    getCertonaDetails() {
        const { productCartridgeSlots, isLoaded, isPriceLoaded, removeLoader } = this.state;
        const {
            slotDetails: { slotId },
            onCartridgeLoad,
            disablePricingCall,
            adobeMap = {},
            productCartridgeSlots: propsProductCartidgeSlots,
            bottomPadding,
            showLoader,
            emptyProductsReceived,
        } = this.props;
        const abodeMappedSlotID = Object.keys(adobeMap)[Object.values(adobeMap).indexOf(slotId)];
        const scheme =
            productCartridgeSlots?.[slotId] || propsProductCartidgeSlots?.[abodeMappedSlotID];
        if (scheme?.display === 'no') {
            if (emptyProductsReceived && !isLoaded) {
                emptyProductsReceived();
            }
            this.setState({ isLoaded: true });
            return null;
        }
        const cartrides = this.getProductCartridges();
        const certonaLoaded = cartrides.length || removeLoader;
        if (certonaLoaded) {
            // TODO: to correct the logic behind using this flag
            // Suggestion: should be used this.removeLoader
            this.setState({
                removeLoader: false,
            });

            // If pricing is not loaded, need to init the pricing call
            if (
                !isPriceLoaded &&
                !disablePricingCall &&
                productCartridgeSlots?.[slotId]?.isPriceLoaded
            ) {
                this.setState({
                    productCartridgeSlots: this.props.productCartridgeSlots,
                    isPriceLoaded: true,
                });
            }
            if (emptyProductsReceived && cartrides.length === 0 && scheme) {
                emptyProductsReceived();
            }
            if (onCartridgeLoad) {
                onCartridgeLoad(slotId);
            }
            this.setState({ isLoaded: true });
            return (
                <div
                    className={` ${dt([bottomPadding])} ${dt([cartrides.length ? 'mb-6' : ''])}`}
                    data-component-name="CoreZonesContainer"
                >
                    {cartrides}
                </div>
            );
        }
        if (!certonaLoaded && showLoader) {
            return (
                <div
                    className={dt([
                        'border',
                        'border-gray-15',
                        'border-solid',
                        'relative',
                        'h-[350px]',
                    ])}
                >
                    <Loader />
                </div>
            );
        }
        return null;
    }

    loadProductListForCartridgeSlot(regionZone) {
        const {
            slotDetails,
            productCartridgeSlots,
            schemasToRender,
            forceRefresh,
            adobeScheme,
            isAdobe,
            actions,
        } = this.props;
        // check if certona zones are already loaded.
        if (productCartridgeSlots?.[schemasToRender] && !forceRefresh) {
            this.setState({
                productCartridgeSlots,
                removeLoader: true,
            });
        } else {
            const isLoggedIn = { isLoggedIn: User.isUserLoggedIn() };
            const sendProps = { ...this.props, ...slotDetails, ...isLoggedIn, ...adobeScheme };
            if (regionZone) {
                sendProps.regionZone = regionZone;
            }
            const forceMobileObj = {
                isDesktop: false,
                isMobile: true,
                isTablet: false,
            };
            sendProps.deviceType = sendProps?.forceMobile ? forceMobileObj : sendProps?.deviceType;
            sendProps.isAdobe = isAdobe;
            actions?.getProductListForCartridgeSlot(sendProps);
        }
    }

    /*
      this function is used for refresh certona based on prop refreshCertona
    */
    refreshProductListForCartridgeSlot(nextProps) {
        const { productCartridgeSlots, schemasToRender } = nextProps;
        const { actions } = this.props;
        if (!productCartridgeSlots?.[schemasToRender]) {
            actions?.addProductCartridgeSlot({
                [schemasToRender]: {
                    scheme: schemasToRender,
                },
            });
            const { slotDetails, refreshCertona } = nextProps;
            const sendProps = { ...this.props, ...slotDetails, schemasToRender, refreshCertona };
            actions?.getProductListForCartridgeSlot(sendProps);
            this.setState({
                isLoaded: false,
                isPriceLoaded: false,
            });
        } else if (productCartridgeSlots?.[schemasToRender]?.isPriceLoaded) {
            this.setState({
                productCartridgeSlots,
                removeLoader: true,
            });
        }
    }

    render() {
        const {
            page = '',
            wrapperClass = '',
            deviceType,
            schemasToRender,
            productCartridgeSlots,
            slotDetails,
        } = this.props;
        const brandZoneProps = { deviceType, schemasToRender, productCartridgeSlots, slotDetails };
        return (
            <ErrorBoundary>
                {/* B2b voucher condition */}
                {!isAgentLogged() && (
                    <>
                        {slotDetails?.style === 'brand' ? (
                            <BrandRecZone {...brandZoneProps} />
                        ) : (
                            <div data-whoami={`${page}-coreZones`} className={wrapperClass}>
                                {this.getCertonaDetails()}
                            </div>
                        )}
                    </>
                )}
            </ErrorBoundary>
        );
    }
}

export const mapStateToProps = ({
    productCartridge: { productCartridgeSlots = {} } = {},
    context: {
        deviceType = { isDesktop: true },
        featureFlags: { disablePricingCall = false } = {},
        preferences: {
            fpac: { certona = {} } = {},
            recommendations: { adobeMap, adobeScheme } = {},
        } = {},
    } = {},
}) => ({
    productCartridgeSlots,
    deviceType,
    disablePricingCall,
    pricingConfig: certona,
    adobeMap,
    adobeScheme,
});

export const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        { getProductListForCartridgeSlot, removeProductCartridgeSlot, addProductCartridgeSlot },
        dispatch
    ),
});

export default compose(
    withReducerSaga([ProductCartridgeReducer], [watchProductListRequest, watchResetProductList]),
    connect(mapStateToProps, mapDispatchToProps)
)(CertonaZone);
